export default "__VITE_PUBLIC_ASSET__b9773cfa__"